import React from "react";
export default function NotFound() {
  return (
    <div className="card">
      <h1>404</h1>
      <p>Page not found.</p>
    </div>
  );
}
